import Image from "next/image";
import React from "react";
import styles from "./admission-consultation.module.css";
import video from "../../assets/images/free-consult/centers.svg";
import phone from "../../assets/images/free-consult/phone.svg";
import whatsapp from "../../assets/images/free-consult/whatsapp.svg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { useState } from "react";
import { createuser } from "../../components/Service/admissionConsultation";
import ReCAPTCHA from "react-google-recaptcha";
import dynamic from 'next/dynamic';
import Head from "next/head";
const Otpverification = dynamic(()=>import("../../components/Modal/Otpverification"));

const Consultation = () => {
  const [verified, setverified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [modalOtpstatus, setmodalOtpstatus] = useState(null);
  const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
  const [valuephno, setvaluephno] = useState(undefined);
  const [captchaerror, setcaptchaerror] = useState(undefined);

  function convertJsonStringToNumber(jsonString) {
        // Parse the JSON string to an object
        const jsonObject = JSON.parse(jsonString);
        // Iterate over the keys and convert numeric strings to numbers
        for (const key in jsonObject) {
          if (jsonObject.hasOwnProperty(key)
    && !isNaN(jsonObject[key])) {
            jsonObject[key] = Number(jsonObject[key]);
          }
        }

    return jsonObject;
}

  function onChange(value) {
    if (value == null) {
      setverified(false);
    }
    else {
      setverified(true);
    }
  }

  async function handleOnSubmit(e) {
    e.preventDefault();
    if (verified) {
      const formData = {};
      formData['formType'] = "admissionconsultation";
      formData['title'] = "Admission Consultation";
      Array.from(e.currentTarget.elements).forEach((field) => {
        if (!field.name) return;
        formData[field.name] = field.value;
      });

      //formData['countryCode'] = "+91";
      formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
      formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
      const transform={fields:{...formData}};
      console.log(transform);

       setIsLoading(true);
       createuser(transform)
           .then(response => {
              
               setModalOtp(true);
               setmodalOtpstatus(response.message);
               window.grecaptcha.reset(setverified);
               setverified(false);
               setvaluephno(undefined);
               document.getElementById("consultform").reset();
               setIsLoading(false);
           })
           .catch(error => {
            setModalOtp(true);
            setmodalOtpstatus("failure");
            window.grecaptcha.reset(setverified);
            setverified(false);
            setIsLoading(false);
          })
    }
    else {
      setcaptchaerror(true);
      setTimeout(() => {
        setcaptchaerror(false);
      }, 3000);

    }
  }


  return (
    <>
     {isLoading &&
        <div className="APIPreLoader" id="APIPreLoader">
          <div className="loader">Loading...</div>
        </div>
      }
             <Head>
                <meta charset="UTF-8" />
                 
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>Admission Consultation | Shankar IAS Academy</title>
                <meta name="title" content="Admission Consultation | Shankar IAS Academy" />
                <meta name="description" content="Shankar IAS Academy offers expert admission consultation. Explore programs, application process, and embark on your journey towards UPSC excellence." />
                <link rel="canonical" href="https://www.shankariasacademy.com/admission-consultation/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Admission Consultation | Shankar IAS Academy" />
                <meta property="og:description" content="Shankar IAS Academy offers expert admission consultation. Explore programs, application process, and embark on your journey towards UPSC excellence." />
                <meta property="og:url" content="https://www.shankariasacademy.com/admission-consultation/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>

      <Otpverification show={modalOtp} title={modalOtpstatus} frompage="admissionconsultation" onHide={() => setModalOtp(false)} />


      <Navbar title="admission consultation" />

      <div className="container">
        <div className="row">
          <div className="col pt-3 pt-md-5">
            <h1 className={`${styles.pagemaintitle}`}>
              Admission Consultation
            </h1>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row pt-3 justify-content-center">
          {/* <div className="col-lg-4 col-md-6 col-12 mb-3 mb-lg-0">
            <div className={`${styles.consult}`}>
              <div
                className={`${styles.consultnormal} py-4`}
                id={styles.consultnormal1}
              >
                <div className="p-5 p-md-3 p-lg-4 text-center">
                  <Image
                    src={video}
                    className="img-fluid"
                    alt="Goverment exam service"
                    title="Free consultant over a video call"
                  />
                  <p className={`${styles.acheiverrank} pt-2`}>
                    Free Consultation <br />
                    over video call
                  </p>
                </div>
              </div>

              <div
                className={`${styles.consulthover} py-4`}
                id={styles.consulthoverfade1}
              >
                <div className="p-5 p-md-3 p-lg-4 text-center">
                  <Image
                    src={video}
                    className="img-fluid"
                    alt="Goverment exam service"
                    title="Free consultant over a video call"
                  />
                  <p className={`${styles.redunderline} mb-0 pt-2`}>
                    <a href="https://wa.me/+919003190030" className={`${styles.redunderlinealink}`}>
                      Click here
                    </a>
                  </p>
                  <p className={`${styles.acheiverrank}`}>
                    to start a video call
                  </p>
                </div>
              </div>
            </div>
          </div> */}

          <div className="col-md-6 col-12 mb-3 mb-lg-0">
            <div className={`${styles.consult}`}>
              <div
                className={`${styles.consultnormal} py-4`}
                id={styles.consultnormal2}
              >
                <div className="p-5 p-md-3 p-lg-4 text-center">
                  <Image
                    src={phone}
                    className="img-fluid"
                    alt="Goverment exam service"
                    title="Free consultant over a phone"
                  />
                  <p className={`${styles.acheiverrank} pt-2`}>
                    Free Consultation <br />
                    over phone
                  </p>
                </div>
              </div>

              <div
                className={`${styles.consulthover} pb-2 pt-1`}
                id={styles.consulthoverfade2}
              >
                <div className="p-5 p-md-3 p-lg-4">
                  <div className="row">
                    <div className="col-xl-9 col-md-10 col-12 mx-auto">
                      <div className="row">
                        <div className="col-md-5 col-6">
                          <p className={`${styles.acheiverrank} mb-0`}>UPSC</p>
                        </div>
                        <div className="col-md-7 col-6">
                          <p className={`${styles.acheivername} mb-0`}>
                            <a
                              href="tel:9003190030"
                              className={`${styles.numberbold}`}
                            >9003190030 
                            </a>{" "}
                             <br />
                               <br />
                            {/* <a
                              href="tel: 044 66024500"
                              className={`${styles.numberbold}`}
                            >
                            044 66024500
                            </a> */}
                          </p>
                        </div>
                        <hr
                          className={`${styles.borderfromtabview} mx-md-auto`}
                        />
                        <div className="col-md-5 col-6">
                          <p className={`${styles.acheiverrank} mb-0`}>TNPSC</p>
                        </div>
                        <div className="col-md-7 col-6">
                          <p className={`${styles.acheivername} mb-0`}>
                              <a
                              href="tel:7667766266"
                              className={`${styles.numberbold}`}
                            >7667766266  
                            </a>   {" "}
                             / <br />                       
                            <a
                              href="tel:044-43533445"
                              className={`${styles.numberbold}`}
                            >
                              044 43533445
                            </a>{" "}
                            / <br />
                            <a
                              href="tel:044 45543082"
                              className={`${styles.numberbold}`}
                            >
                              044 45543082
                            </a>
                          </p>
                        </div>
                        <hr
                          className={`${styles.borderfromtabview} mx-md-auto`}
                        />
                        <div className="col-md-5 col-6">
                          <p className={`${styles.acheiverrank} mb-0`}>
                            Test Series
                          </p>
                        </div>
                        <div className="col-md-7 col-6">
                          <p className={`${styles.acheivername} mb-0`}>
                            <a
                              href="tel:9003190030"
                              className={`${styles.numberbold}`}
                            >
                              9003190030
                            </a>
                          </p>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-12 mb-3 mb-lg-0">
            <div className={`${styles.consult}`}>
              <div
                className={`${styles.consultnormal} py-4`}
                id={styles.consultnormal3}
              >
                <div className="p-5 p-md-3 p-lg-4 text-center">
                  <Image
                    src={whatsapp}
                    className="img-fluid"
                    alt="Goverment exam service"
                    title="Free consultant over a whatsapp"
                  />
                  <p className={`${styles.acheiverrank} pt-2`}>
                    Free Consultation <br />
                    through whatsapp
                  </p>
                </div>
              </div>

              <div
                className={`${styles.consulthover} py-4`}
                id={styles.consulthoverfade3}
              >
                <div className="p-5 p-md-3 p-lg-4 text-center">
                  <Image
                    src={whatsapp}
                    className="img-fluid"
                    alt="Goverment exam service"
                    title="Free consultant over a whatsapp"
                  />
                  <p className={`${styles.redunderline} mb-0 pt-2`}>
                    <a href="https://wa.me/+919003190030" target="blank" className={`${styles.redunderlinealink}`}>
                      Click here
                    </a>
                  </p>
                  <p className={`${styles.acheiverrank}`}>
                    to chat in WhatsApp
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-9 col-lg-6 col-12 mx-auto pt-md-5 pt-4">
            <p className={`${styles.acheiverrank} text-center mb-0`}>
              Or if you want to write to us, kindly drop your details in the
              below form.
            </p>
            <p className={`${styles.acheiverrank} text-center`}>
              We will get in touch with you shortly.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-md-7 col-lg-5 col-12 mx-auto">
            <form onSubmit={handleOnSubmit} id="consultform" autoComplete="off">
              <div className="row pt-5">
                <div className="col-12">
                  <div className="mb-4">
                    <p className="text-start mb-0">
                      <label
                        htmlFor="exampleInputName"
                        className={`${styles.acheiverrank} form-label`}
                      >
                        Name<span className={`${styles.formstar}`}>*</span>
                      </label>
                    </p>
                    <input
                      type="text"
                      className={`${styles.acheiverrank} form-control`}
                      autoComplete="off"
                      pattern="[A-Za-z]{3,}"
                      name="name"
                      minLength="3"
                      required
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="mb-4">
                    <p className="text-start mb-0">
                      <label
                        htmlFor="exampleInputmail"
                        className={`${styles.acheiverrank} form-label`}
                      >
                        Email Address
                        <span className={`${styles.formstar}`}>*</span>
                      </label>
                    </p>
                    <input
                      type="email"
                      className={`${styles.acheiverrank} form-control`}
                      autoComplete="off"
                      name="emailAddress"
                      pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$"
                      aria-describedby="emailHelp"
                      required
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="mb-4">
                    <p className="text-start mb-0">
                      <label
                        htmlFor="exampleInputPhno"
                        className={`${styles.acheiverrank} form-label`}
                      >
                        Phone No<span className={`${styles.formstar}`}>*</span>
                      </label>
                    </p>
                    <input type="tel" className={`${styles.acheiverrank} form-control`} name="phoneNo" pattern="[0-9]{10}" maxlength="10" required />
                  </div>
                </div>

                <div className="col-12">
                  <div className="mb-4">
                    <p className="text-start mb-0">
                      <label
                        htmlFor="exampleInputMessage*"
                        className={`${styles.acheiverrank} form-label`}
                      >
                        Message (optional)
                      </label>
                    </p>
                    <textarea style={{ height: "87px" }}
                      type="textarea"
                      className={`${styles.acheiverrank} form-control`}
                      autoComplete="off"
                      minLength="2"
                      name="query"
                    ></textarea>
                  </div>
                </div>

                <div className="col-12 col-xl-8 col-md-10 mx-auto text-center">
                  <ReCAPTCHA className={`${styles.captcha}`}
                    sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                    onChange={onChange}
                  />
                  <div className="">
                    {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                  </div>
                </div>

                <div className="col-12 mb-4 pt-2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id={styles.invalidCheck2}
                    />
                    <label
                      className={`${styles.checkboxcontent} form-check-label`}
                      for="invalidCheck2"
                    >
                      I would like to receive updates from Shankar IAS Academy
                    </label>
                  </div>
                </div>

                <p className="text-center">
                  <button className={`${styles.normalbutton}`} type="submit">
                    Send
                  </button>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>



      <Footer />
    </>
  );
};
export default Consultation;
